import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../components/site/Logo";
import Footer from "../../components/site/Footer";
import { ArrowLeft } from "lucide-react";
import useSeo from "../../hooks/useSeo";

export default function LegalShell({ title, updated, description, path, children }) {
  useSeo({
    title: `${title} — España Eficiente (E²)`,
    description: description || `${title} de España Eficiente (E²).`,
    path: path || "",
  });
  return (
    <div className="bg-[#FAFAFA] min-h-screen flex flex-col">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-link">
            <Logo />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-bold text-espana-red hover:text-espana-reddark transition-colors"
          >
            <ArrowLeft size={16} /> Volver al inicio
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 py-14">
          <div className="h-1.5 w-24 bg-espana-red mb-6" />
          <h1 className="text-3xl sm:text-4xl font-black tracking-tight">{title}</h1>
          {updated && (
            <p className="mt-2 text-sm text-gray-400">Última actualización: {updated}</p>
          )}
          <div className="mt-8 legal-content space-y-5 text-gray-700 leading-relaxed">
            {children}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
